<template>
  <el-dialog
    :title="dialogTitle"
    width="460px"
    :visible.sync="isShow"
    :close-on-click-modal="false"
  >
    <p v-if="['XZPT_Person_List'].includes(this.$route.name) && ['确认封禁'].includes(this.dialogTitle)" style="padding-left:10px;">确认对【{{msg}}】进行封禁操作吗？</p>
    <p v-if="['XZPT_Person_List'].includes(this.$route.name) && ['确认禁用'].includes(this.dialogTitle)" style="padding-left:10px;">确认对【{{msg}}】进行禁用操作吗？</p>
    <p v-if="['XZPT_Company_List'].includes(this.$route.name) && ['确认封禁'].includes(this.dialogTitle)" style="padding-left:10px;">确认对【{{msg}}】进行封禁操作吗？</p>
    <p v-if="['XZPT_Company_List'].includes(this.$route.name) && ['确认禁用'].includes(this.dialogTitle)" style="padding-left:10px;">确认对【{{msg}}】进行禁用操作吗？</p>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="60px" style="margin-top: 10px;">
      <el-form-item label="原因: " prop="reason">
        <el-input type="textarea" :rows="4"
          placeholder="请输入原因"
          style="width: 300px;"
          v-model="ruleForm.reason">
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="isShow = false">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { disable, ban } from '@/api/tenant';
export default {
  name: '',
  computed: {
    rules () {
      return {
        reason: [
          { required: true, message: '请输入原因', trigger: 'blur' },
        ],
      };
    },
  },
  methods: {
    initPage () {
      this.isShow = true;
      this.ruleForm.reason = '';
      console.log('routeName', this.$route.name);
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
    },
    handleSubmit () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let currentParams = {
            id: this.tenantId,
            reason: this.ruleForm.reason,
          };
          if (['确认禁用'].includes(this.dialogTitle)) {
            disable(currentParams).then(() => {
              this.$emit('handleRefresh');
              this.isShow = false;
            });
          } else if (['确认封禁'].includes(this.dialogTitle)) {
            ban(currentParams).then(() => {
              this.$emit('handleRefresh');
              this.isShow = false;
            });
          }
        }
      });
    },
  },
  data () {
    return {
      isShow: false,
      dialogTitle: '确认禁用',
      msg: '',
      tenantId: '',
      ruleForm: {
        reason: '',
      },
    };
  },
};
</script>
<style scoped lang='scss'>
/* @import url(); 引入css类 */

</style>

